import { ErrorCode, FileRejection } from "react-dropzone";
import { PendingFile } from "./createEscalation.models";
import { MAX_IMAGES_PER_COMMENT } from "./createEscalation.constants";
import { message } from "antd";

function getRejectionMessage(fileName: string, code: string): string {
    switch (code) {
        case ErrorCode.FileInvalidType:
            return `"${fileName}": Only PNG and JPEG images are allowed.`
        case ErrorCode.FileTooLarge:
            return `"${fileName}": File is larger than 10 MB.`
        case ErrorCode.FileTooSmall:
            return `"${fileName}": File is too small.`
        case ErrorCode.TooManyFiles:
            return `Maximum ${MAX_IMAGES_PER_COMMENT} images allowed.`
        default:
            return `"${fileName}": ${code}`
    }
}

const fileToPendingFile = (file: File, index: number): PendingFile => ({
    id: `${file.name}-${Date.now()}-${index}`,
    name: file.name,
    file,
})

export const onDropAccepted = (acceptedFiles: File[], setPendingFiles: React.Dispatch<React.SetStateAction<PendingFile[]>>) => {
    setPendingFiles((prev) => {
        const remaining = MAX_IMAGES_PER_COMMENT - prev.length
        const toAdd = acceptedFiles.slice(0, remaining).map((file, index) => fileToPendingFile(file, index))
        return [...prev, ...toAdd]
    })
}

export const onDropRejected = (fileRejections: FileRejection[]) => {
    const messages = fileRejections.flatMap(({ file, errors }) =>
        errors.map((e) => getRejectionMessage(file.name, e.code))
    )
    const unique = [...new Set(messages)]
    unique.forEach((msg) => message.error(msg))
}

